<template>
    <div class="cookie-banner d-flex flex-column align-center" v-if="showBanner && !loading">
        <!-- Conteudo padrão -->
        <div class="w-80 d-flex justify-center mt-2 flex-column  text-center" v-if="!config_cookie_mode">
            <p class="font-cookies-title">Nós usamos cookies</p>
            <p class="font-cookies">Utilizamos ferramentas e serviços que utilizam cookies para melhorar e aprimorar sua experiência de navegação na plataforma de vendas. Ao clicar no botão "Permitir todos", você concorda com o uso de cookies.</p>
            <span class="d-flex justify-center flex-wrap w-100 knowmore">
                <div style="flex:1" class="text-md-end text-center mr-sm-5 mr-2">
                    <a class="know-more-link mb-2 " @click="openCookiesTerms">Saber mais</a>
                </div>
                <div style="flex:1" class="text-md-start text-center ">
                    <a class="know-more-link mb-2" @click="turnInConfigCookieMode">Definição de Cookies</a>
                </div>
            </span>
        </div>
        <div v-else class="d-flex mt-2 flex-column position-relative">
            <button class="back-button" @click="turnOffConfigCookieMode"><v-icon size="30">mdi-arrow-left</v-icon></button>
            <p class="font-cookies-title text-center">Configurações de Cookies</p>
            <p class="font-cookies text-center">Selecione os cookies que deseja desativar:</p>

            <div class="d-flex justify-center flex-column " style="max-width:720px;width:90vw;align-self: center;">
                <div class="d-flex justify-start">
                    <v-checkbox
                            input-value="true"
                            value
                            disabled
                    ></v-checkbox> <label class="mt-1 font-cookies">Cookies Essenciais</label>
                </div>
                <div class="d-flex justify-start">
                    <v-checkbox
                            v-model="navigation_cookies_permission"
                    ></v-checkbox> <label class="mt-1 font-cookies">Cookies de Navegação</label>
                </div>
            </div>
        </div>
        <!-- Conteudo quando o usuário deseja personalizar os cookies -->
        <v-row v-if="!config_cookie_mode" class="button-container d-flex w-100">
            <v-btn color="info" class="accept-button mb-2" @click="acceptCookies">Permitir todos</v-btn>
            <v-btn color="advice" class="reject-button" @click="rejectCookies">Rejeitar cookies não necessários</v-btn>
        </v-row>
        <v-row v-if="config_cookie_mode" class="button-container d-flex">
            <v-btn color="info" class="accept-button mb-2" @click="salvarCookies">Salvar Configurações</v-btn>
        </v-row>
    </div>
</template>

  <script>
  import { mapState } from 'vuex'
  import vue_cookies from 'vue-cookies'

  export default {
    name: 'CookieConsent',
    props: {
      loading: Boolean
    },
    data () {
      return {
        showBanner: false,
        config_cookie_mode: false,
        navigation_cookies_permission: true
      }
    },
    computed: {
      ...mapState(['id_usuario', 'deve_verificar_cookies', 'permitiu_cookies'])
    },
    async mounted () {
      if (!vue_cookies.isKey('cookie_configuration')) {
        this.showBanner = true
      } else {
        this.showBanner = false
        const cookie_config = vue_cookies.get('cookie_configuration')
        if (!cookie_config.navigation_cookies_permission) {
          this.showBanner = true
        }
      }
    },
    methods: {
      acceptCookies () {
        this.navigation_cookies_permission = true
        this.salvarCookies()
      },
      rejectCookies () {
        this.navigation_cookies_permission = false
        this.salvarCookies()
      },
      async salvarCookies () {
        this.showBanner = false
        if (!this.navigation_cookies_permission) {
          this.limparTodosCookies()
        }
        this.salvarConfiguracaoCookiesSessao()
      },
      limparCookie (nome) {
        document.cookie = nome + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
      },
      limparTodosCookies () {
        var cookies = document.cookie.split(';')
        for (var i = 0; i < cookies.length; i++) {
          var cookie = cookies[i]
          var igualPosicao = cookie.indexOf('=')
          var nome = igualPosicao > -1 ? cookie.substr(0, igualPosicao) : cookie
          this.limparCookie(nome)
        }
      },
      openCookiesTerms () {
        const cookieTermsPath = 'cookies'
        const baseUrl = process.env.BASE_URL
        const fullCookieTermsPath = `${baseUrl}#/${cookieTermsPath}`
        window.open(fullCookieTermsPath, '_blank')
      },
      turnInConfigCookieMode () {
        this.config_cookie_mode = true
      },
      turnOffConfigCookieMode () {
        this.config_cookie_mode = false
      },
      shouldShowBanner () {
        return true
      },
      salvarConfiguracaoCookiesSessao () {
        const config = { 'navigation_cookies_permission': this.navigation_cookies_permission }
        vue_cookies.set('cookie_configuration', config, Infinity, null, null, true)
      }
    }
  }
  </script>

  <style scoped>
  .cookie-banner {
    position: fixed;
    bottom: 100px;
    left: 0;
    width: 100%;
    background-color: #f0f0f0;
    padding: 10px;
    text-align: center;
    z-index: 9999;
  }

  .button-container {
    display: flex;
    justify-content: center;
    margin-top: 10px;
  }

  .accept-button,
  .reject-button {
    padding: 6px 12px;
    font-size: 1.1rem !important;
    color:aliceblue;
    width: 360px;
    max-width: 95vw;
    margin: 0 10px;
  }
  .font-cookies{
    font-size: 1.2rem;
    text-align: justify;
  }
  .w-80{
    width: 80%;
  }
  .w-100{
    width:100%;
  }
  .back-button{
    font-size:1.2rem;
    position:absolute;
    left:0;
  }
  .know-more-link{
    font-size: 1.4rem;
    text-decoration: underline;
  }
  .font-cookies-title{
    font-size: 1.4rem;
  }
  @media (max-width: 600px) {
    .accept-button,
    .reject-button {
      font-size: 12px !important;
    }
  }

  </style>
